import React from "react";
import EditIcon from "../../../images/icons/white/edit.svg";
import DeleteIcon from "../../../images/icons/white/delete.svg";
import { getLabelColor } from '../../../helpers';
import { CircleCheckBox } from "../../../components/form/CircleCheckBox";
import { ensureHash } from "../../../helpers/ensureHash";

function ContentLabelSelector(props) {
  const {
    selected,
    labelId,
    labelName,
    colorHex,
    onUpdate,
    onEdit,
    onDelete,
    can_access_edit_label
  } = props

  const handleToggle = (close_popup = false) => {
    onUpdate(labelId, !selected, close_popup)
  }

  const label_color = getLabelColor(colorHex)
  const label_color_bg = ensureHash(colorHex)

  return (
    <div className="content-label-selector">
      <span
        className={ "content-label-selector__checkbox-container d-flex align-items-center cursor-pointer" }
        onClick={ () => handleToggle(false) }
      >
        <CircleCheckBox 
          isChecked={ selected }
          checkIconColor= { label_color.text }
          checkedBackgroundColor={colorHex ? label_color_bg : '#FFFFFF'}
          height={18}
          width={18}
          whiteChecked={true}
          strokeWidth={1}
        />
      </span>


      <div
        className={ "content-label-selector__details cursor-pointer" }
        style={{ backgroundColor: label_color_bg }}
        onClick={ () => handleToggle(true) }>
        <span
          style = {{
            color: label_color.text
          }}>
          { labelName }
        </span>
        <div className="d-flex align-items-center">
          <img
            src={ EditIcon }
            title="Edit"
            width="15"
            onClick={ (e) => onEdit(labelId, e) }
            style={{marginTop: 0, filter: label_color.text != 'white' ? 'invert(88%)' : null }}
            className="cursor-pointer edit-icon"
          />

          <img
            src={ DeleteIcon }
            title="Edit"
            width="15"
            onClick={ (e) => onDelete(labelId, e) }
             style={{marginTop: 0, display: 'none'}}
            className="cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
}

export default ContentLabelSelector
